export class ContactDataModel {

  email: string;
  phoneNumber: string;

  constructor() {
    this.email = '';
    this.phoneNumber = '';
  }
}
